<template>
  <div class="dizi" @click="gowai">
    <div>
      {{ data }}
    </div>
  </div>
</template>

<script>
import {nameType} from "@/api/service";

export default {
  name: "bottomList",

  data() {
    return {
      data: "",
    };
  },

  mounted() {
  },
  created() {
    if (nameType === 1) {
      //座联
      this.data = "浙ICP备2025181830号"
    } else if(nameType === 2) {
      //岩克
      this.data = "浙ICP备2025203821号"
    } else if(nameType === 3) {
      //易勋科技
      this.data = "浙ICP备2025203822号"
    }else if(nameType === 4) {
      //岚序供应链
      this.data = "浙ICP备2025185674号"
    }else if(nameType === 5) {
      //杭州座联
      this.data = "浙ICP备2025213580号"
    }else if(nameType === 6) {
      //杭州曼琛科技有限公司
      this.data = "浙ICP备2026043077号"
    }
  },
  methods: {
    gowai() {
      window.open("https://beian.miit.gov.cn/");
    },
  },
};
</script>

<style lang="less" scoped>
.dizi {
  font-size: 10rem;
  padding: 10rem 20rem;
  text-align: center;

  div {
    line-height: 20rem;
    color: #666;
  }
}
</style>
